define('app-UKTSDetails/main',["./settings", "text!../app-UKTSBookingSummary/ConfirmationPrompt/view.html", "../app/ui/dialog", "jquery"], function (settings, view, dialog) {
    return {
        run: function () {
            var container = $(settings.container);

            if (container.length === 0) {
                return;
            }

            var loadingDialog = dialog.show("Please wait", "", { noClose: true});
            var shouldCallUpdatePrice = false;

            var getBookUkTravelDetails = $.ajax({
                url: settings.getBookUkTravelDetailsUrl
            });

            getBookUkTravelDetails.done(function (response) {
                container.html(response);
                loadingDialog.close();
            });

            var passengerDepartureAddressEqual = function () {
                var selectedAddresses = [];

                container.find(".departureOptions input:checked").each(function () {
                    selectedAddresses.push($(this).val());
                });

                return selectedAddresses.every(function (address) {
                    return address === selectedAddresses[0];
                });
            }

            var allPassengersSelectedService = function (serviceType) {
                var selectedServiceTypes = [];

                container.find(".requiredService input:checked").each(function () {
                    selectedServiceTypes.push($(this).val());
                });

                return selectedServiceTypes.every(function (selectedService) {
                    return selectedService === serviceType.toString();
                });
            }
            var sharedCarType = 1;
            var showhideButton = function () {
                   if (allPassengersSelectedService(sharedCarType) && $(settings.buttonContainer).data("carserviceincluded") === "True") {
                        $(settings.addToBookingButton).removeClass("d-none");
                        $(settings.getQuoteButton).addClass("d-none");

                    } else {
                        $(settings.addToBookingButton).addClass("d-none");
                        $(settings.getQuoteButton).removeClass("d-none");
                        
                    }
               };
            container.on("change", ".requiredService input", function () {
                var carType = $(this).val();

                if (passengerDepartureAddressEqual()) {
                    container.find(".requiredService input").each(function () {
                        if ($(this).val() === carType) {
                            $(this).prop("checked", true);
                        }
                    });
                }

                showhideButton();

                // hide the price if changing service
                var priceContainer = $("#ukTravelPrice");

                priceContainer.addClass("d-none");
                priceContainer.find(".price").html("");
                shouldCallUpdatePrice = true;
            });

            container.on("change", ".departureOptions input", function () {
                var firstSelectedService = container.find(".requiredService input:checked").first();
                var carType = firstSelectedService.val();

                if (passengerDepartureAddressEqual()) {
                    container.find(".requiredService input").each(function () {
                        if ($(this).val() === carType) {
                            $(this).prop("checked", true);
                        }
                    });
                }
            });

            var getUkTravelRequest = function () {
                var data = [];

                container.find(".ukt-service").each(function (index) {
                    var $this = $(this);
                    var routeContainer = $this.find(".yourRoute");
                    var passengerIds = $this.data("passengerids").toString().split(",");

                    data[index] = {
                        "SelectedServiceType": $this.find(".requiredService input:checked").val(),
                        "SelectedPickupAddress": routeContainer.find(".departureOptions input:checked").val(),
                        "SelectedDropOffAddress": routeContainer.find(".arrivalOptions input:checked").val(),
                        "PassengerIds": passengerIds,
                        "FromDestination": $this.find(".fromDestination").text(),
                        "ToDestination": $this.find(".toDestination").text(),
                        "OutBoundDate": $this.data("outbounddate"),
                        "InBoundDate": $this.data("inbounddate")
                    };
                });

                return {
                    "IndividualUkTravelServiceRequest": data
                }
            }

            container.on("click", settings.getQuoteButton, function () {
                var myDialog = dialog.show("Please wait while we retrieve your quote", "", { noClose: true });
                var request = getUkTravelRequest();

                $.post(settings.updatePriceUrl, request, function(updatePrice) {
                            var priceContainer = $("#ukTravelPrice");

                            if (updatePrice > 0) {
                                priceContainer.find(".price").html(updatePrice);
                                priceContainer.removeClass("d-none");
                            } else {
                                priceContainer.addClass("d-none");
                            }

                            $(settings.addToBookingButton).removeClass("d-none");
                            $(settings.getQuoteButton).addClass("d-none");
                        })
                    .always(function() {
                        myDialog.close();
                    });
            });

            var addToBookingDialog;
            container.on("click", settings.addToBookingButton, function () {
                var ukTravelPrice = $("#ukTravelPrice .price").text();
                var buttonContainer = container.find(settings.buttonContainer);
                
                if (allPassengersSelectedService(sharedCarType) && buttonContainer.data("carserviceincluded") === "True") {
                   shouldCallUpdatePrice = true;
                }

                var popupContent;

                if (ukTravelPrice === "" || ukTravelPrice <= 0) {
                    popupContent = "You are about to book the VIP door-to-door car service, which is included in your holiday. Would you like to proceed?";
                } else {
                    popupContent = "You are about to book the VIP door-to-door car service for £" + ukTravelPrice + ". Would you like to proceed?";
                }

                var popupHtml = view.replace("{content}", popupContent);

                addToBookingDialog = dialog.show("UK Travel", popupHtml, { noClose: true });
            });

            $("body").on("click", ".uk-travel-dialog-button", function () {
                var $this = $(this);

                if ($this.data("book").toLowerCase() === "no") {
                    addToBookingDialog.close();
                } else {
                    var request = getUkTravelRequest();
                    var ukTravelPrice = $("#ukTravelPrice .price").text();

                    // default to 0.00
                    if (!ukTravelPrice) {
                        ukTravelPrice = "0.00";
                    }

                    request["Price"] = ukTravelPrice;
                        
                    dialog.show("Please wait", "", { noClose: true});

                    if (shouldCallUpdatePrice) {
                        $.post(settings.updatePriceUrl, request,
                            function() {
                                confirmUkTravelService(request);
                            });
                    } else {
                        confirmUkTravelService(request);
                    };
                }
            });

            function confirmUkTravelService(request) {
                $.post(settings.confirmUrl, request, function (confirm) {
                    window.location.href = confirm.returnURL;
                });
            }
        }
    };
});
